module.exports = __webpack_public_path__ + "img/planet-mars.888bc1d7.webp";